import { useErrorNotification } from '@/hooks/use-error-notification';
import type { NormalizedError } from '@/utils/error-utils';
import { useCallback } from 'react';

// Custom hook for showing error notifications specifically for create price actions.
// When we have a consistent setup for handling row-level errors custom hook can most likely be removed.
export const useCreatePriceErrorNotification = () => {
  const showErrorNotification = useErrorNotification();

  return useCallback(
    (error: NormalizedError, action: string) => {
      if (error.status === 422) {
        // Row-level errors are an array, which the shared validation summary can't format
        showErrorNotification(
          { kind: 'problem', status: 422, message: error.message },
          action,
        );
        return;
      }
      showErrorNotification(error, action);
    },
    [showErrorNotification],
  );
};
